import Typography from '@mui/material/Typography'
import React, { FunctionComponent } from 'react'

export const PageHeading: FunctionComponent = ({ children }) => (
  <Typography variant="h5" component="h1">
    {children}
  </Typography>
)
